import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';

// Access gates (flag / module / permission), breadcrumb and icon live on the
// parent pass-through route so the details pages outside ~overview inherit
// them too — this layout only adds the tabs and the header they share.
export const Route = createFileRoute('/console/$orgId/tools/compliance-audit/overview')({
    staticData: {
        ui: {
            title: 'Compliance audit',
            subtitle: 'Run compliance audits and review their findings and insights',
            useTitleForChildren: true,
        },
    },
    component: ComplianceAuditLayout,
});

function ComplianceAuditLayout() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    {
                        label: 'Audits',
                        to: '/console/$orgId/tools/compliance-audit/overview/search',
                    },
                    {
                        label: 'Insights',
                        to: '/console/$orgId/tools/compliance-audit/overview/insights',
                    },
                ]}
            />
        </PageController>
    );
}
